var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tool-calendar-component',{attrs:{"toolId":_vm.toolId},on:{"updated":function($event){return _vm.$emit('updated')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }